import React from "react";
import { DISCLAIMER_SHORT } from "../content/disclaimer";
import "./DisclaimerNotice.css";

export default function DisclaimerNotice({ onOpenFull }) {
    return (
        <p className="disclaimer-notice" role="note">
            <span className="disclaimer-notice-text">{DISCLAIMER_SHORT}</span>{" "}
            <button
                type="button"
                className="disclaimer-notice-link"
                onClick={onOpenFull}
            >
                Full disclaimer
            </button>
        </p>
    );
}
